import React from 'react'

const OperationsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 66 66"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#8aba55"
                        d="M27.4 17c0-1.11-.17-2.19-.48-3.2l2.87-1.85-3.24-5.05-2.88 1.85a11.261 11.261 0 0 0-4.27-2.33V3h-6v3.42c-1.6.45-3.05 1.26-4.27 2.33L6.25 6.9 3 11.95l2.87 1.85c-.3 1.01-.47 2.09-.47 3.2s.17 2.19.48 3.2L3 22.05l3.25 5.05 2.88-1.85c1.22 1.07 2.67 1.88 4.27 2.33V31h6v-3.42c1.6-.45 3.05-1.26 4.27-2.33l2.88 1.85 3.25-5.05-2.87-1.85c.3-1.01.47-2.09.47-3.2zm-11 6c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                        opacity={1}
                        data-original="#8aba55"
                        className=""
                    />
                    <path
                        fill="#7cb5e8"
                        d="M60.6 49c0-1.11-.17-2.19-.48-3.2L63 43.95l-3.25-5.05-2.88 1.85a10.996 10.996 0 0 0-4.27-2.33V35h-6v3.42c-1.6.45-3.05 1.26-4.27 2.33l-2.88-1.85-3.25 5.05 2.87 1.85a10.918 10.918 0 0 0 0 6.4l-2.87 1.85 3.25 5.05 2.88-1.85c1.22 1.07 2.67 1.88 4.27 2.33V63h6v-3.42c1.6-.45 3.05-1.26 4.27-2.33l2.88 1.85L63 54.05l-2.87-1.85c.3-1.01.47-2.09.47-3.2zm-11 6c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"
                        opacity={1}
                        data-original="#7cb5e8"
                    />
                    <path
                        fill="#ffab03"
                        d="M18.02 36.29c.39 1.8 1.1 3.48 2.06 4.98l-2.42 3.27 3.8 3.8 3.27-2.42c1.5.96 3.18 1.67 4.98 2.06l.6 4.02h5.37l.6-4.02c1.8-.39 3.48-1.1 4.98-2.06l3.27 2.42 3.8-3.8-2.42-3.27c.96-1.5 1.67-3.18 2.06-4.98l4.02-.6v-5.37l-4.02-.6c-.39-1.8-1.1-3.48-2.06-4.98l2.42-3.27-3.8-3.8-3.27 2.42c-1.5-.96-3.18-1.67-4.98-2.06L35.69 14h-5.37l-.6 4.02c-1.8.39-3.48 1.1-4.98 2.06l-3.27-2.42-3.8 3.8 2.42 3.27c-.96 1.5-1.67 3.18-2.06 4.98l-4.03.6v5.37zM25.75 33c0-4.01 3.25-7.25 7.25-7.25 4.01 0 7.25 3.25 7.25 7.25S37 40.25 33 40.25c-4.01 0-7.25-3.24-7.25-7.25z"
                        opacity={1}
                        data-original="#ffab03"
                        className="hovered-path"
                    />
                    <path
                        fill="#fff"
                        d="m45.92 24.73 2.42-3.27-3.8-3.8-3.27 2.42c-1.5-.96-3.18-1.67-4.98-2.06l-.6-4.02h-5.37l-.6 4.02c-1.8.39-3.48 1.1-4.98 2.06l-.59-.43a17.324 17.324 0 0 0 1.8 11.7A7.25 7.25 0 0 1 40.26 33c0 2.95-1.76 5.47-4.28 6.61 1.66.53 3.43.81 5.27.81 1.98 0 3.88-.35 5.65-.95.47-1.01.85-2.07 1.09-3.19l4.02-.6v-5.37l-4.02-.6c-.4-1.8-1.11-3.48-2.07-4.98z"
                        opacity=".3"
                    />
                    <g fill="#4e6575">
                        <path d="M64.53 30.47a.754.754 0 0 0-1.06 0l-1.74 1.74C61.31 16.72 48.59 4.25 33 4.25c-.41 0-.75.34-.75.75s.34.75.75.75c14.75 0 26.79 11.78 27.23 26.42l-1.7-1.7c-.29-.29-.77-.29-1.06 0s-.29.77 0 1.06l3 3c.15.15.34.22.53.22s.38-.07.53-.22l3-3c.29-.29.29-.77 0-1.06zM33 60.25c-14.75 0-26.79-11.78-27.23-26.42l1.7 1.7c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-3-3a.754.754 0 0 0-1.06 0l-3 3c-.29.29-.29.77 0 1.06s.77.29 1.06 0l1.74-1.74C4.69 49.28 17.41 61.75 33 61.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z" />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default OperationsIcon